"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _MuiButton = _interopRequireDefault(require("./MuiButton"));
var _MuiFab = _interopRequireDefault(require("./MuiFab"));
var _MuiAvatar = _interopRequireDefault(require("./MuiAvatar"));
var _MuiCheckbox = _interopRequireDefault(require("./MuiCheckbox"));
var _MuiDialogActions = _interopRequireDefault(require("./MuiDialogActions"));
var _MuiExpansionPanel = _interopRequireDefault(require("./MuiExpansionPanel"));
var _MuiExpansionPanelSummary = _interopRequireDefault(require("./MuiExpansionPanelSummary"));
var _MuiExpansionPanelDetails = _interopRequireDefault(require("./MuiExpansionPanelDetails"));
var _MuiFormLabel = _interopRequireDefault(require("./MuiFormLabel"));
var _MuiLink = _interopRequireDefault(require("./MuiLink"));
var _MuiRadio = _interopRequireDefault(require("./MuiRadio"));
var _MuiSwitch = _interopRequireDefault(require("./MuiSwitch"));
var _FormLabel = _interopRequireDefault(require("./FormLabel"));
var _default = {
  FormLabel: _FormLabel["default"],
  MuiButton: _MuiButton["default"],
  MuiFab: _MuiFab["default"],
  MuiAvatar: _MuiAvatar["default"],
  MuiCheckBox: _MuiCheckbox["default"],
  MuiDialogActions: _MuiDialogActions["default"],
  MuiExpansionPanel: _MuiExpansionPanel["default"],
  MuiExpansionPanelSummary: _MuiExpansionPanelSummary["default"],
  MuiExpansionPanelDetails: _MuiExpansionPanelDetails["default"],
  MuiFormLabel: _MuiFormLabel["default"],
  MuiLink: _MuiLink["default"],
  MuiRadio: _MuiRadio["default"],
  MuiSwitch: _MuiSwitch["default"]
};
exports["default"] = _default;